import { connect } from "react-redux"

import {
    sourceListSearchRequest,
    sourceListInvalidationRequest,
    sourceSetFilter,
    sourceAddNew
} from "../../../actions/source-actions"

import SourceListWidget from "./SourceListWidget"

const mapStateToProps = ({
    presentation: { sources },
    paging,
    authentication
}) => ({
    isFetching:
        sources.isFetchingList ||
        sources.isFetchingItem ||
        sources.isDeletingItem,
    pagingRequest: paging.sources[sources.searchCriteria],
    nameSearchTerm: sources.workingFilterModel.name,
    isAddingEnabled: authentication.permissions.indexOf("w_source") !== -1
})

const mapDispatchToProps = dispatch => ({
    invalidate: pagingRequest => () =>
        dispatch(sourceListInvalidationRequest(pagingRequest)),
    onFilterSelect: pagingRequest => () =>
        dispatch(sourceSetFilter(true, pagingRequest.searchCriteria)),
    onSearch: ({ target: { name, value } }) =>
        dispatch(sourceListSearchRequest(name, value)),
    onAdd: () => dispatch(sourceAddNew())
})

export default connect(mapStateToProps, mapDispatchToProps)(SourceListWidget)
